import { Switch, Route, Redirect } from 'react-router-dom';
import HomePage from 'pages/home';
import AppPage from 'pages/app';
import AboutPage from 'pages/about';
import ContactPage from 'pages/contact';
import { PrivacyPolicyApp } from 'pages/privacyPolicy';
import iot from './iot';
import mechanicalVentilation from './mechanicalVentilation';
import hemodynamic from './hemodynamic';

const Routes = () => {
  return (
    <Switch>
      <Route exact path='/' component={HomePage} />
      {iot}
      {mechanicalVentilation}
      {hemodynamic}
      <Route exact path='/app' component={AppPage} />
      <Route exact path='/about' component={AboutPage} />
      <Route exact path='/contact' component={ContactPage} />
      <Route exact path='/privicy-policy-app' component={PrivacyPolicyApp} />
      <Redirect exact from='*' to='/' />
    </Switch>
  );
};

export default Routes;
